import CloseIcon from 'assets/icons/close.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import {Text} from 'ui';
import { classNameType } from 'utils/types';

import s from './Popup.module.scss';

const cx = cn.bind(s);

const PopupContent = ({
  children, hasCloseIcon = true, title, className, onClose = () => { }, ...attrs
}) => (
  <div className={cx(className, 'popup')} {...attrs}>
    {hasCloseIcon && <button className={cx('closeIcon')} onClick={onClose}>
      <CloseIcon />
    </button> }
    {title && <Text as="h3" className={cx('title')}>{title}</Text>}
    {children}
  </div>
);

PopupContent.propTypes = {
  title: PropTypes.string,
  className: classNameType,
};
export default PopupContent;
